module.exports = __webpack_public_path__ + "img/dj.4ed230c7.svg";